module.exports = __webpack_public_path__ + "daa5c03e8faf1a1459f0c45da0a49b52.png";